export default "__VITE_ASSET__iFZ0OrNO__"